module.exports = __webpack_public_path__ + "static/img/1990.cfb3910a.jpg";